<!--
frontend-author:Pramoth,
backend-author: bhavya,
page-name :AmcContract.vue,
page-description :AMC Contract details,
started at : 09-oct-2019,
edited at : 09-oct-2019.
-->
<!-- Html code for AMC Contract details -->
<template>
  <div>
    <b-row class="reports-header px-pad border-bottom" style="height:42px">
      <b-col xl="10" lg="10" md="10" sm="10" class="px-0">
        <GlobalDateRangePicker
          class="pr-3"
          ref="daterangeupdate"
          :singleDatePicker="false"
          v-on:setDateRange="getDateRange($event,1)"
          :fromDate="from_date"
          :toDate="to_date"
        />
        <b-dropdown dropdown variant="light" size="sm" class="no-caret-dropdown mb-xs">
          <template slot="button-content">
            <span v-if="selectedfilter.filter_name">
              <i class="fa fa-filter la-lg mr-1"></i>
              {{selectedfilter.filter_name}}
            </span>
            <span v-else>
              <i class="la la-cog la-lg mr-1"></i>Customize Report
            </span>
          </template>

          <b-dropdown-item v-b-modal.amccontract>General</b-dropdown-item>
          <template v-if="reportsfilter.length>0">
            <b-dropdown-divider />
            <div class="mb-2">
              <span class="pl-4 text-link fw-semi-bold">Your Custom Filters</span>
            </div>
          </template>
          <b-dropdown-item v-for="item in reportsfilter" :key="item.id">
            <div class="d-flex">
              <a
                class="report_button mb-0 w-75 text-truncate"
                @click="runcustomreport(item)"
              >{{ item.filter_name }}</a>
              <i
                class="la la-edit la-lg text-right ml-2 mr-3 ml-auto"
                @click="filterpage = 'update',filteritems=item"
                v-b-modal.savefilterform
              ></i>
              <i
                class="glyphicon glyphicon-trash text-right"
                @click="handlingapprovingmodal({
                  content : 'Are you sure you want to delete this customize filter ?',
                  title : 'Delete customize filter - '+item.filter_name,
                  module:'general/deletecustomfilter',
                  data:JSON.stringify({
                    id : item.filter_id,
                    report_type: $route.meta.title
                  }),
                  RoutePlace:'',
                  isRoute:'false',
                  type: 'delete'
                })"
              ></i>
            </div>
          </b-dropdown-item>
        </b-dropdown>
        <span
          class="btn-link cursor_pointer ml-2 fw-semi-bold"
          v-if="!selectedfilter.filter_id"
          @click="filterpage = 'create',savefilterform()"
        >Save filter</span>
      </b-col>
      <b-col xl="2" lg="2" md="2" sm="2" class="px-0">
        <router-link class="event-link float-right mt-2" :to="{ name : 'Reports'}">
          <i class="la la-remove la-lg text-decoration-none text-dark"></i>
        </router-link>
      </b-col>
    </b-row>
    <div>
      <!-- {{group_total_amount}}
      <br />
      {{lists}}-->

      <b-row class="pt-2">
        <b-col lg="12" xl="12" md="12" sm="12" class="px-0">
          <div class="text-center text-normal">
            <p class="mb-1">{{ org_name }}</p>
            <h4 class="fw-semi-bold">AMC Contract</h4>
            <p
              class="text-sm text-muted mb-2"
            >{{ 'From ' + getDateFormat(from_date) +' To '+ getDateFormat(to_date) }}</p>
          </div>
          <div class="table-responsive" id="reportScrollCol">
            <!--  sales by customer Table-->
            <table class="table table-bordered reports-table-border table-no-bordered">
              <!--  sales by customer Table head-->

              <thead>
                <tr>
                  <th style="width:280px !important">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'AmcContractReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: count,custom:$route.query.custom,group_by:$route.query.group_by,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'pdt_name' } }"
                    >
                      Product Name
                      <small class="text-muted" v-if="label == 'pdt_name'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="width:140px !important" class="text-right">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'AmcContractReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: count,custom:$route.query.custom,group_by:$route.query.group_by,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'used_service' } }"
                    >
                      Used Service
                      <small class="text-muted" v-if="label == 'used_service'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                  <th style="width:155px !important" class="text-right">
                    <router-link
                      class="text-dark text-decoration-none"
                      :to="{ name : 'AmcContractReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page,show: count,custom:$route.query.custom,group_by:$route.query.group_by,sort:sort == 'asc' ? 'desc' : 'asc' ,label:'unused_service' } }"
                    >
                      Unused Service
                      <small class="text-muted" v-if="label == 'unused_service'">
                        <i
                          :class="[{'fa fa-fw' : true},'fa-sort-'+sort]"
                          style="font-weight:thinner;"
                        ></i>
                      </small>
                    </router-link>
                  </th>
                </tr>
              </thead>
              <!--  Sales by Customer Table body and data -->

              <template v-if="lists.length == 0&&group_total_amount.length==0">
                <tbody>
                  <tr>
                    <td colspan="4" class="text-center">No data to display</td>
                  </tr>
                </tbody>
              </template>
              <tbody
                v-for="(item,index) in group_total_amount"
                :key="index"
                v-if="getPresentValue(lists,$route.query.group_by,item[$route.query.group_by]) == true"
              >
                <tr
                  v-if="$route.query.group_by=='amc_hdr_id'"
                  style="background:#f8f9fa;cursor:pointer"
                >
                  <td colspan="5" v-b-toggle="'pdt_collapse'+index">
                    <div class="w-100">
                      <div class="fw-semi-bold float-left w-50 text-truncate">{{item.pdt_name}}</div>
                      <div
                        class="fw-semi-bold float-right text-right w-50"
                      >{{orgCurrencySymbol+' '+Number(item.total_value).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 })}}</div>
                    </div>

                    <b-collapse :id="'pdt_collapse'+index" class="mt-4" visible>
                      <table class="collapse-table">
                        <tr>
                          <td colspan="4">
                            <small>Customer Details</small> :
                            <span
                              class="fw-semi-bold"
                            >{{ item.cus_name!=""&&item.cus_name!=null?item.cus_name:'-' }} - {{item.cus_ph_no_1!=""&&item.cus_ph_no_1!=null?'('+item.cus_ph_no_1+')':''}}</span>
                          </td>
                        </tr>
                        <tr>
                          <td style="width:210px">
                            <small>Next Service</small> :
                            <span
                              class="fw-semi-bold"
                            >{{ item.next_service_date!=""&&item.next_service_date!=null?getDateFormat(item.next_service_date):'-' }}</span>
                          </td>
                          <td style="width:210px">
                            <small>Last Service</small> :
                            <span
                              class="fw-semi-bold"
                            >{{ item.last_service_date!=""&&item.last_service_date!=null?getDateFormat(item.last_service_date):'-' }}</span>
                          </td>
                          <td style="width:210px">
                            <small>Expiry</small> :
                            <span
                              class="fw-semi-bold"
                            >{{ item.expiry_date!=""&&item.expiry_date!=null?getDateFormat(item.expiry_date):'' }}</span>
                          </td>
                          <td></td>
                        </tr>
                      </table>
                    </b-collapse>
                  </td>
                </tr>
                <tr v-else style="background:#f8f9fa">
                  <td colspan="5" v-b-toggle="'pdt_collapse'+index">
                    <div>
                      <div class="fw-semi-bold float-left">
                        {{item.cus_name}}
                        <span>- {{item.cus_ph_no_1!=""&&item.cus_ph_no_1!=null?'('+item.cus_ph_no_1+')':''}}</span>
                      </div>
                      <div
                        class="fw-semi-bold float-right"
                      >{{orgCurrencySymbol+' '+Number(item.total_amc_total).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 })}}</div>
                    </div>
                    <!-- <b-collapse :id="'pdt_collapse'+index" class="mt-4">
                      <table class="float-left collapse-table">
                        <tr>
                          <td>
                            <small>Phone No</small>
                          </td>
                          <td>
                            <small>:</small>
                          </td>
                          <td
                            class="fw-semi-bold"
                          >{{item.cus_ph_no_1!=""&&item.cus_ph_no_1!=null?item.cus_ph_no_1:'-'}}</td>
                        </tr>
                      </table>
                    </b-collapse>-->
                  </td>
                </tr>
                <tr
                  v-for="(list,list_index) in lists"
                  :key="list_index"
                  v-if="list[$route.query.group_by]==item[$route.query.group_by]"
                >
                  <td style="width:280px !important">
                    <span class="text">{{list.pdt_name}}</span>
                  </td>
                  <td class="text-right">{{list.used_service}}</td>
                  <td class="text-right">{{list.unused_service}}</td>
                </tr>
              </tbody>
            </table>
            <p class="ml-4" v-if="lists.length != 0">
              Amount is displayed in your base currency
              <b-badge variant="success" size="xs" style="height:20px">{{orgCurrency}}</b-badge>
            </p>
          </div>
        </b-col>
      </b-row>
    </div>
    <!-- Sales by Item pagination and data showing -->
    <b-row
      v-if="lists.length > 0||arrow"
      style="width: 100%;position: absolute;border-top:1px solid #e0e0e0"
      class="px-pad"
    >
      <b-col xl="5" md="6" lg="6" sm="12" class="mt-2 pt-1 px-0">
        <nav v-if="lists.length > 0" class="float-left">
          <p>
            Showing {{ (total_count != 0 ) ? ((page - 1) * count) + 1 : 0 }} to {{ ((page - 1) * show) + lists.length }}
            of {{ total_count }} entries
            <span
              class="btn-group dropdown"
            >
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                size="xs"
                :show="false"
                :text="count"
                left
              >
                <router-link
                  :to="{ name : 'AmcContractReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: 1,show: 10,custom:$route.query.custom,group_by:$route.query.group_by,sort:sort,label:label} }"
                  class="text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 10">10</b-dropdown-item-button>
                </router-link>
                <router-link
                  :to="{ name : 'AmcContractReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: 1,show: 25,custom:$route.query.custom,group_by:$route.query.group_by,sort:sort,label:label} }"
                  class="text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 25">25</b-dropdown-item-button>
                </router-link>
                <router-link
                  :to="{ name : 'AmcContractReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: 1 ,show: 50,custom:$route.query.custom,group_by:$route.query.group_by,sort:sort,label:label} }"
                  class="text-decoration-none"
                >
                  <b-dropdown-item-button class="page-link" v-if="count != 50">50</b-dropdown-item-button>
                </router-link>
              </b-dropdown>
            </span> rows per page
          </p>
        </nav>
      </b-col>
      <b-col xl="2" md="2" lg="2" sm="4" style="text-align: center;" class="mt-2 pt-1 px-0">
        <div v-if="arrow">
          <a @click="left('#reportScrollCol')" class="mr-2">
            <i class="fa fa-angle-left mr-1 fw-bold round-icon"></i>
          </a>
          <a @click="right('#reportScrollCol')">
            <i class="fa fa-angle-right ml-1 fw-bold round-icon"></i>
          </a>
        </div>
      </b-col>
      <b-col xl="5" md="4" lg="4" sm="12" class="mt-2 pt-1 px-0 d-md-block d-none">
        <template v-if="show<total_count">
          <nav class="float-right">
            <ul class="pagination">
              <li class="page-item">
                <template v-if="page != 1">
                  <router-link
                    class="page-link"
                    :to="{ name : 'AmcContractReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page - 1 ,show: count,custom:$route.query.custom,group_by:$route.query.group_by,sort:sort,label:label} }"
                  >
                    <span aria-hidden="true">&laquo;</span>
                    <span class="sr-only">Previous</span>
                  </router-link>
                </template>
                <template v-else>
                  <a class="page-link" href="#" aria-label="Previous">
                    <span aria-hidden="true">&laquo;</span>
                    <span class="sr-only">Previous</span>
                  </a>
                </template>
              </li>
              <li class="page-item">
                <router-link
                  class="page-link"
                  :to="{ name : 'AmcContractReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: 1 ,show: count,custom:$route.query.custom,group_by:$route.query.group_by,sort:sort,label:label} }"
                >First</router-link>
              </li>
              <li class="page-item">
                <template v-if="page != 1">
                  <router-link
                    class="page-link"
                    :to="{ name : 'AmcContractReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page - 1 ,show: count,custom:$route.query.custom,group_by:$route.query.group_by,sort:sort,label:label} }"
                  >Previous</router-link>
                </template>
                <template v-else>
                  <a href="#" class="page-link">Previous</a>
                </template>
              </li>
              <li class="page-item">
                <template v-if="total_count > (page * count)">
                  <router-link
                    class="page-link"
                    :to="{ name : 'AmcContractReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page + 1,show: count,custom:$route.query.custom,group_by:$route.query.group_by,sort:sort,label:label } }"
                  >Next</router-link>
                </template>
                <template v-else>
                  <a href="#" class="page-link">Next</a>
                </template>
              </li>
              <li class="page-item">
                <router-link
                  class="page-link"
                  :to="{ name : 'AmcContractReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: Math.ceil(total_count / count),show: count,custom:$route.query.custom,group_by:$route.query.group_by,sort:sort,label:label } }"
                >Last</router-link>
              </li>
              <li class="page-item">
                <template v-if="total_count > (page * count)">
                  <router-link
                    class="page-link"
                    :to="{ name : 'AmcContractReport',query: {from_date:$route.query.from_date,to_date:$route.query.to_date,page: page + 1,show: count,custom:$route.query.custom,group_by:$route.query.group_by,sort:sort,label:label } }"
                  >
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                  </router-link>
                </template>
                <template v-else>
                  <a class="page-link" href="#" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                  </a>
                </template>
              </li>
            </ul>
          </nav>
        </template>
      </b-col>
    </b-row>
    <b-modal
      id="amccontract"
      title="Customize Report"
      body-class="bg-white"
      cancel-variant="light"
      ok-title="Run Report"
      size="lg"
      @ok.prevent="selectedfilter={},onRunReport(0)"
      ref="runreport"
      @shown="displayvalue()"
    >
      <b-row>
        <b-col xl="12" lg="12" md="12" xs="12" sm="12">
          <div class="container-fluid">
            <b-alert class="alert-transparent alert-danger" :show="error_show && this.errors.any()">
              <button type="button" @click="error_show=!error_show" class="close">
                <span aria-hidden="true">&times;</span>
              </button>
              <div v-for="(item,index) in items" :key="index">
                <p
                  class="text-danger"
                  v-if="errors.has('filter_matching['+index+']')"
                >Row {{ index + 1 }} : Please enter the matching type</p>
                <p
                  class="text-danger"
                  v-if="errors.has(item.field+'['+index+']')"
                >Row {{ index + 1 }} : Please enter the customize name</p>
                <p
                  class="text-danger"
                  v-if="errors.has('type['+index+']')"
                >Row {{ index + 1 }} : Please enter customize type</p>
                <p
                  class="text-danger"
                  v-if="errors.has('value['+index+']')"
                >Row {{ index + 1 }} : Please enter customize value</p>
              </div>
            </b-alert>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="12" lg="12" md="12" sm="12" xs="12">
          <b-form-group label="Date" label-for="date" :label-cols="2">
            <GlobalDateRangePicker
              :singleDatePicker="false"
              v-on:setDateRange="getDateRange($event)"
              :fromDate="from_date"
              :toDate="to_date"
            />
            <input type="hidden" name="from_date" v-model.trim="from_date" />
            <input type="hidden" name="to_date" v-model.trim="to_date" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="5" lg="5" md="5" sm="5" xs="5">
          <b-form-group>
            <label>Group By</label>
            <b-form-select class="form-control" v-model.trim="group_by">
              <option value="amc_hdr_id">AMC Contract</option>
              <option value="cus_id">Customer</option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-form-group label="Advanced Filters" label-for="adv-filter" :label-cols="5" />
      <b-row v-for="(item,index) in items" :key="index">
        <b-col xl="2" lg="2" md="2" sm="2" xs="2">
          <b-form-group>
            <b-form-select
              class="form-control"
              v-model.trim="item.filter_matching"
              v-validate="'required'"
              :name="'filter_matching['+index+']'"
              v-if="index > 0"
            >
              <option value="and">And</option>
              <option value="or">Or</option>
            </b-form-select>
            <input
              type="text"
              v-else
              class="form-control"
              v-model.trim="item.filter_matching"
              v-validate="'required'"
              :name="'filter_matching['+index+']'"
              disabled
            />
          </b-form-group>
        </b-col>
        <b-col xl="3" lg="5" md="5" sm="5" xs="5">
          <b-form-group>
            <b-form-select
              class="form-control"
              v-model.trim="item.field"
              v-validate="'required'"
              :name="'cust_name['+index+']'"
              @change="item.value = ''"
            >
              <option v-if="group_by!='cus_id'" value="amc_no">AMC Id</option>
              <option v-if="group_by!='cus_id'" value="amc_pdt_id">AMC Product Name</option>
              <option value="cus_id">Customer Name</option>
              <option value="cus_ph_no_1">Phone No</option>
              <option v-if="group_by!='cus_id'" value="amc_start_date">AMC Start Date</option>
              <option v-if="group_by!='cus_id'" value="amc_end_date">AMC Expiry Date</option>
              <option v-if="group_by!='cus_id'" value="renewal_date">Renewal Date</option>
              <option v-if="group_by!='cus_id'" value="next_service_date">Next Service Date</option>
              <option v-if="group_by!='cus_id'" value="total_pdt_qty">Total Product Qty</option>
              <option v-if="group_by!='cus_id'" value="total_used_qty">Total Used Qty</option>
              <option v-if="group_by!='cus_id'" value="amc_total">AMC Total</option>
              <option value="pdt_ids">Product Name</option>
              <option v-if="group_by!='cus_id'" value="amc_tags">AMC Tags</option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col xl="3" lg="5" md="5" sm="5" xs="5">
          <b-form-group>
            <b-form-select
              class="form-control"
              v-model.trim="item.comparator"
              v-validate="'required'"
              :name="'type['+index+']'"
            >
              <template v-if="item.field=='amc_no'||item.field=='cus_ph_no_1'">
                <option value="1">Is</option>
                <option value="2">Is Not</option>
                <option value="5">Starts with</option>
                <option value="6">Ends with</option>
                <option value="7">Contains</option>
                <option value="8">Does not Contains</option>
              </template>
              <template
                v-if="item.field=='amc_start_date'||item.field=='amc_end_date'||item.field=='renewal_date'||item.field=='next_service_date'||item.field=='total_pdt_qty'||item.field=='total_used_qty'||item.field=='amc_total'"
              >
                <option value="1">Is</option>
                <option value="2">Is Not</option>
                <option value="3">Greater than</option>
                <option value="4">Less than</option>
                <option value="12">Greater than or equal to</option>
                <option value="13">Less than or equal to</option>
              </template>
              <template v-if="item.field=='pdt_ids'||item.field=='amc_tags'">
                <option value="10">In</option>
                <option value="11">Not In</option>
              </template>
              <template v-if="item.field=='cus_id'||item.field=='amc_pdt_id'">
                <option value="1">Is</option>
                <option value="2">Is Not</option>
              </template>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col xl="3" lg="5" md="5" sm="5" xs="5" @click="removecustomer($event,index)">
          <div>
            <b-form-group>
              <input
                :type="item.field =='cus_id' || item.field =='pdt_ids' ? 'hidden' : 'text'"
                class="form-control"
                v-model.trim="item.value"
                v-if="item.field =='cus_id' || item.field =='pdt_ids'"
                v-validate="'required'"
                :name="'value['+index+']'"
              />
              <vue-bootstrap-typeahead
                @input="customerlist($event,index)"
                v-model="item.cus_detail_id"
                :id="'customer_search_'+index"
                name="cus_detail_id[]"
                :data="item.customers"
                :class="{'customer_search':true}"
                :serializer="customer => customer.label"
                @hit="checkCustomer($event,index)"
                placeholder="Type to search customer"
                :ref="'cus_name_typeahead_'+index"
                v-show="item.field =='cus_id'"
              />
              <vue-bootstrap-typeahead
                @input="productlist($event,index)"
                v-model="item.pdt_detail_id"
                :id="'product_search_'+index"
                name="pdt_detail_id[]"
                :data="item.products"
                :class="{'product_search':true}"
                :serializer="product => product.label"
                @hit="checkProduct($event,index)"
                placeholder="Type to search product"
                :ref="'pdt_name_typeahead_'+index"
                v-show="item.field =='pdt_ids'"
              >
                <template slot="suggestion" slot-scope="{ data, htmlText }">
                  <span>{{ data.label }}</span>&nbsp;
                  <br />
                  <small class="pr-3" v-if="data.pdt_legacy_id">{{data.pdt_legacy_id }}</small>
                  <small>{{ data.pdt_sku }}</small>
                </template>
              </vue-bootstrap-typeahead>
              <DatePicker
                v-validate="'required'"
                v-model.trim="item.value"
                @input="checkdate($event,index)"
                v-if="item.field == 'amc_start_date' || item.field == 'renewal_date' || item.field == 'amc_end_date'||item.field=='next_service_date'"
                input-name="amc_start_date"
                lang="en"
                input-class="form-control"
                style="width:100% !important;"
                :name="'value['+index+']'"
                :format="$AppDetails.organization.date_format"
              >
                <i class="fa fa-calendar text-dark" slot="calendar-icon" />
              </DatePicker>
              <b-form-select
                v-else-if="item.field == 'amc_tags'||item.field == 'amc_pdt_id'"
                class="form-control"
                v-model.trim="item.value"
                v-validate="'required'"
                :name="'value['+index+']'"
              >
                <template v-if="item.field == 'amc_pdt_id'">
                  <option
                    :value="option.value"
                    v-for="option in amc_pdt_list"
                    :key="option.id"
                  >{{ option.label }}</option>
                </template>
                <template v-if="item.field == 'amc_tags'">
                  <option
                    :value="option.value"
                    v-for="option in tag_list"
                    :key="option.id"
                  >{{ option.label }}</option>
                </template>
              </b-form-select>

              <input
                :type="item.field =='cus_id' ||item.field =='pdt_ids' ? 'hidden' : 'text'"
                class="form-control"
                v-model.trim="item.value"
                v-else
                v-validate="'required'"
                :name="'value['+index+']'"
              />
            </b-form-group>

            <!-- End of Values -->
          </div>
        </b-col>
        <b-col xl="1" lg="1" md="1" sm="1" xs="1">
          <b-form-group>
            <span>
              <i class="glyphicon glyphicon-trash" @click="removeRow(index)"></i>
            </span>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="12" md="12" lg="12" sm="12" xs="12">
          <span
            class="text-link cursor_pointer fw-semi-bold"
            @click="addNewRow()"
            v-if="items.length<10"
          >+ Add more</span>
          <span v-else>
            <i class="fa fa-exclamation-triangle pl-2 text-warning fa-md"></i>
            Filter conditions must be within ten criteria
          </span>
        </b-col>
      </b-row>
    </b-modal>
    <SaveFilterForm :saveforfuture="saveforfuture" :page="filterpage" :item="filteritems" />
    <GlobalModal
      :content="content"
      :module="module"
      :title="title"
      :data="globalmodaldata"
      :isRoute="isRoute"
      :RoutePlace="RoutePlace"
      :type="globalmodaltype"
    />
  </div>
</template>
<!-- Sales by Customer  Script -->
<script>
import { scrollTable } from "@/mixins/scrollTable"; //functions call for table scroll

import { mapState, mapGetters } from "vuex";
import store from "@/store/index";
import moment from "moment";
import SaveFilterForm from "@/pages/Reports/SaveFilterForm";
import $ from "jquery";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import DatePicker from "vue2-datepicker";

import { formatDate } from "@/mixins/formatDate";
function getPageAmcContractReport(routeTo, next) {
  const currentPage = parseInt(routeTo.query.page) || 1;

  const show = parseInt(routeTo.query.show) || 10;
  const sort = routeTo.query.sort || "";
  const label = routeTo.query.label || "";
  store
    .dispatch("reports/fetchAmcContractLists", {
      page: currentPage,
      show: show,
      sort: sort,
      label: label,
      query: routeTo.query
    })
    .then(() => {
      routeTo.params.page = currentPage;
      routeTo.params.show = show;
      routeTo.params.sort = sort;
      routeTo.params.label = label;
      next();
    });
}
export default {
  components: {
    DatePicker,
    SaveFilterForm,
    VueBootstrapTypeahead
  },
  mixins: [formatDate, scrollTable],
  props: {
    page: {
      type: Number,
      required: true
    },
    show: {
      type: Number,
      required: true
    },

    label: [String, Number],
    sort: [String, Number]
  },
  name: "AmcContractReport",
  data() {
    return {
      error_show: false,
      show_detail: [false, false, false, false, false],
      items: [],
      arrow: false,
      group_by: "amc_hdr_id",
      org_name: this.$AppDetails.organization.comp_name || "",
      saveforfuture: {},
      filterpage: "create",
      filteritems: "",
      isRoute: "",
      RoutePlace: "",
      content: "",
      module: "",
      globalmodaltype: "",
      globalmodaldata: "",
      title: "",
      psort: this.sort,
      plabel: this.label,
      from_date:
        this.$route.query.from_date ||
        this.formatDate(moment().startOf("month")),
      to_date:
        this.$route.query.to_date || this.formatDate(moment().endOf("month"))
    };
  },

  updated() {
    this.arrow = this.scrollbar($("#reportScrollCol")) ? true : false;
  },
  mounted() {
    this.arrow = this.scrollbar($("#reportScrollCol")) ? true : false;
  },
  created() {
    if (!$.isEmptyObject(this.selectedfilter)) {
      this.runcustomreport(this.selectedfilter);
    } else if (this.$route.query.constructor === Object) {
      this.$router.push({
        name: this.$route.name,
        query: {
          from_date: this.from_date,
          to_date: this.to_date,
          filter: "",
          group_by: "amc_hdr_id"
        }
      });
    }
  },
  methods: {
    //To get the correct date
    checkdate(val, index) {
      this.items[index].value =
        val == "" || typeof val == "undefined" || val == null
          ? ""
          : this.formatDate(val);
    },
    displayvalue() {
      for (var i = 0; i <= this.items.length; i++) {
        this.$refs["cus_name_typeahead_" + i][0].inputValue = this.items[
          i
        ].cus_detail_id;

        this.$refs["pdt_name_typeahead_" + i][0].inputValue = this.items[
          i
        ].pdt_detail_id;
        //  mask and remover
        $("#customer_search_" + i + " input").css("pointer-events", "none");
        $("#customer_search_" + i + " input").css(
          "background-color",
          "#f7f7f7"
        );
        $("#customer_search_" + i + " input").css("position", "relative");
        $("#customer_search_" + i + " .input-group").append(
          "<span class='la la-close p-2' id='customer_remove_" + i + "'></span>"
        );
        $("#customer_remove_" + i).css("position", "absolute");
        $("#customer_remove_" + i).css("right", "0");

        //
        $("#product_search_" + i + " input").css("pointer-events", "none");
        $("#product_search_" + i + " input").css("background-color", "#f7f7f7");
        $("#product_search_" + i + " input").css("position", "relative");
        $("#product_search_" + i + " .input-group").append(
          "<span class='la la-close p-2' id='product_remove_" + i + "'></span>"
        );
        $("#product_remove_" + i).css("position", "absolute");
        $("#product_remove_" + i).css("right", "0");
      }
    },
    //check customer
    checkCustomer(event, index) {
      $("#customer_search_" + index + " input").css("pointer-events", "none");
      $("#customer_search_" + index + " input").css(
        "background-color",
        "#f7f7f7"
      );
      $("#customer_search_" + index + " input").css("position", "relative");
      $("#customer_search_" + index + " .input-group").append(
        "<span class='la la-close p-2' id='customer_remove_" +
          index +
          "'></span>"
      );
      $("#customer_remove_" + index).css("position", "absolute");
      $("#customer_remove_" + index).css("right", "0");
      this.items[index].value = event.value;
    },
    removecustomer(e, index) {
      if (e.target.matches("#customer_remove_" + index)) {
        $("#customer_search_" + index + " input").css("pointer-events", "all");
        $("#customer_search_" + index + " input").css(
          "background-color",
          "#fff"
        );
        $("#customer_search_" + index + " input").css("position", "");
        $("#customer_remove_" + index).remove();
        var cus_name = "cus_name_typeahead_" + index;
        this.$refs[cus_name][0].inputValue = "";
        this.items[index].value = "";
      }
      if (e.target.matches("#product_remove_" + index)) {
        $("#product_search_" + index + " input").css("pointer-events", "all");
        $("#product_search_" + index + " input").css(
          "background-color",
          "#fff"
        );
        $("#product_search_" + index + " input").css("position", "");
        $("#product_remove_" + index).remove();
        var pdt_name = "pdt_name_typeahead_" + index;
        this.$refs[pdt_name][0].inputValue = "";
        this.items[index].value = "";
      }
    },
    //check product
    checkProduct(event, index) {
      $("#product_search_" + index + " input").css("pointer-events", "none");
      $("#product_search_" + index + " input").css(
        "background-color",
        "#f7f7f7"
      );
      $("#product_search_" + index + " input").css("position", "relative");
      $("#product_search_" + index + " .input-group").append(
        "<span class='la la-close p-2' id='product_remove_" +
          index +
          "'></span>"
      );
      $("#product_remove_" + index).css("position", "absolute");
      $("#product_remove_" + index).css("right", "0");
      this.items[index].value = event.value;
    },

    //product list
    productlist(event, index) {
      if (event != "") {
        store
          .dispatch(
            "general/fetchProductData",
            JSON.stringify({ field: event })
          )
          .then(() => {
            this.items[index].products = this.product_filter_list;
          });
      }
    },
    //customer list
    customerlist(event, index) {
      if (event != "") {
        store.dispatch("general/fetchCustomerData", event).then(() => {
          this.items[index].customers = this.customer_filter_list;
        });
      }
    },
    getPresentValue(arr, prop, val) {
      var hasMatch = false;
      for (var i = 0; i < arr.length; i++) {
        if (arr[i][prop] == val) {
          hasMatch = true;
          break;
        }
      }
      return hasMatch;
    },

    addNewRow() {
      this.items.push({
        filter_matching: "",
        customers: [],
        products: [],
        pdt_detail_id: "",
        cus_detail_id: "",
        field: "",
        comparator: "",
        value: ""
      });
      this.items[0].filter_matching = "When";
    },
    removeRow(index) {
      var i;
      if (typeof this.items[parseInt(index) + 1] != "undefined") {
        for (i = index; i < this.items.length - 1; i++) {
          var cus_name = "cus_name_typeahead_" + i;
          this.$refs[cus_name][0].inputValue = this.items[i + 1].cus_detail_id;
        }
      }
      this.items.splice(index, 1);
      if (typeof this.items[parseInt(index)] != "undefined") {
        this.items[0].filter_matching = "When";
      }
    },
    getDateRange(event, runreport) {
      this.from_date = event.startDate;
      this.to_date = event.endDate;
      if (runreport == 1) {
        this.onRunReport();
      }
    },
    async savefilterform() {
      this.saveforfuture = await {
        to_date: this.to_date,
        from_date: this.from_date,
        label: this.label,
        sort: this.sort,
        group_by: this.group_by,
        items: this.items
      };
      await this.$root.$emit("bv::show::modal", "savefilterform");
    },
    runcustomreport(item) {
      this.selectedfilter = item;
      var filter_content = JSON.parse(item.filter_content);
      this.to_date = filter_content.to_date;
      this.from_date = filter_content.from_date;
      this.plabel = JSON.parse(JSON.stringify(filter_content.label));
      this.psort = JSON.parse(JSON.stringify(filter_content.sort));
      this.group_by = filter_content.group_by;
      this.items = filter_content.items;
      this.onRunReport(0);
    },
    //  delete whole invoice
    handlingapprovingmodal(ev) {
      this.content = ev.content;
      this.module = ev.module;
      this.globalmodaldata = ev.data;
      this.title = ev.title;
      this.isRoute = ev.isRoute;
      this.RoutePlace = ev.RoutePlace;
      this.globalmodaltype = ev.type;
      this.$root.$emit("bv::show::modal", "handlingapprovingmodal");
    },
    onRunReport(runreport) {
      var group_by = this.group_by;
      this.$validator.validateAll().then(result => {
        if (result) {
          if (runreport == 0 && this.$refs.daterangeupdate) {
            var child = this.$refs.daterangeupdate;
            child.checkConsole({
              startDate: this.from_date,
              endDate: this.to_date
            });
          }
          this.$router.push({
            name: this.$route.name,
            query: {
              from_date: this.from_date,
              to_date: this.to_date,
              custom: JSON.stringify({
                columns: JSON.stringify(this.items)
              }),
              group_by,
              label: $.isEmptyObject(this.selectedfilter)
                ? this.label
                : this.plabel,
              sort: $.isEmptyObject(this.selectedfilter)
                ? this.sort
                : this.psort
            }
          });
        } else {
          this.error_show = true;
        }
      });
    }
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    store.dispatch("amccontract/fetchamccontractdetails");
    store.dispatch(
      "general/getallcustomfilter",
      JSON.stringify({
        report_type: routeTo.meta.title
      })
    );
    getPageAmcContractReport(routeTo, next);
  },
  beforeRouteUpdate(routeTo, routeFrom, next) {
    typeof this.$refs.runreport != "undefined"
      ? this.$refs.runreport.hide()
      : "";
    typeof this.$refs.run != "undefined" ? this.$refs.run.hide() : "";
    getPageAmcContractReport(routeTo, next);
  },
  computed: {
    ...mapGetters(["orgCurrencySymbol", "orgCurrency"]),

    ...mapState({
      tag_list: state => state.amccontract.tag_list,
      lists: state => state.reports.lists,
      total_count: state => state.reports.total_count,
      count: state => state.reports.count,
      total_amount: state => state.reports.total_amount,
      group_total_amount: state => state.reports.group_total_amount,
      amc_pdt_list: state => state.amccontract.amc_pdt_list,
      customer_filter_list: state => state.general.customer_filter_list,
      product_filter_list: state => state.general.product_filter_list,
      reportsfilter: state => state.general.reportsfilter
    }),
    selectedfilter: {
      get() {
        return this.$store.state.general.selectedfilter;
      },
      set(val) {
        this.$store.state.general.selectedfilter = val;
      }
    }
  }
};
</script>

<!--  Sales by Customer style -->
<style scoped>
.pagination > .page-item > .page-link,
.pagination > .page-item > span {
  border-radius: unset;
  margin: 0;
  background: transparent;
}
.ver-align {
  padding-top: 10px;
  text-decoration: none;
}
.content {
  position: relative;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  padding: 40px 40px 60px;
  background-color: #fff;
}
.collapse-table td {
  border: none;
  padding: 3px !important;
}
.collapse-table {
  width: 100%;
}
</style>